// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3l-2";
export var cell = "_3l-6";
export var cellContainer = "_3l-3";
export var disabled = "_3l-5";
export var featuredIconCellContainer = "_3l-7";
export var featuredIconTextContainer = "_3l-9";
export var featuredIconWrapper = "_3l-8";
export var hasRowsSelected = "_87-1";
export var noBorder = "_3l-a";
export var overflowableText = "_3l-0";
export var overflowableTextContainer = "_3l-1";
export var row = "_3o-0";
export var rowCheckboxCell = "_3l-4";
export var selectableTable = "_87-2";